__webpack_require__.p = "https://qa-qr-code-generator.digital.vpsvc.com/";